// src/logService.js
export async function logErrorToDiscord(message) {
    const webhookUrl = 'https://discord.com/api/webhooks/1388183265738756238/WGRseSe3yL62w2cvaGmv94uPktGsSFdh-TX9Ni-r8KpkQ4QWoABiyBZ8moiwoFQs-DzC';
  
    const payload = {
      content: message,
    };
  
    try {
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        console.error('Error logging to Discord:', response.statusText);
      }
    } catch (error) {
      console.error('Error logging to Discord:', error);
    }
  }
  